import React from 'react';
import { LinearProgress } from "@material-ui/core";
import { useSelector } from "react-redux";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Login from "../Login";
import Account from "../Account";
import Businesses from "../Businesses";
import Page404 from "../Page404";
import ChooseBusiness from "../ChooseBusiness";
import Dashboard from '../Dashboard';
import Offline from '../Offline';
import PublicSite from '../Site/Public';


function LoggedIn(props) {
  const loading = useSelector(state => state.app.loading);

  return (
    <>
      {loading && <LinearProgress />}

      <Switch>
        <Route path='/' component={ChooseBusiness} exact />
        <Route path='/business/:businessId' component={Dashboard} />
        <Route path='/business' component={ChooseBusiness} />
        <Route path='/account' component={Account} />
        <Route path='/admin/businesses' component={Businesses} />

        <Route component={Page404} />
      </Switch>
    </>
  );
}

function LoggedOut(props) {
  const loading = useSelector(state => state.app.loading);

  return (
    <>
      {loading && <LinearProgress />}

      <Switch>
        <Route path='/business/:businessId/site/:siteId' component={PublicSite} />
        <Route component={Login} />
      </Switch>
    </>
  );
}


function Root(props) {
  const auth = useSelector(state => state.auth);
  const app = useSelector(state => state.app);

  return (
    <Router>
      <Switch>
        {app.online
          ? auth.loggedIn
            ? <LoggedIn />
            : <LoggedOut />
          : <Offline />}
      </Switch>
    </Router>
  );
}

export default Root;